import React, {useMemo} from 'react';
import {View, StyleSheet} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {tokens} from '../theme/tokens';
import {buildEtaParts} from '../utils/time';
import {OrderStatusDto} from '../model/types';
import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';

type HeaderProps = Pick<
  OrderStatusDto,
  | 'orderType'
  | 'etaText'
  | 'estimatedPickupTime'
  | 'pickupTimeZone'
  | 'pickupLocation'
  | 'isReady'
> & {locationName?: string};

export const Header: React.FC<HeaderProps> = (p) => {
  const eta = buildEtaParts(
    p.orderType,
    p.etaText,
    p.estimatedPickupTime,
    p.pickupTimeZone,
    p.isReady,
  );

  const locationLine = useMemo(() => {
    const main = (p.locationName || '').trim();
    const sub = (p.pickupLocation || '').trim();
    if (main && sub && sub.toLowerCase() !== 'pickup') {
      return `${main}, ${sub}`;
    }
    return main || sub;
  }, [p.locationName, p.pickupLocation]);

  return (
    <View style={styles.wrap}>
      <AVText style={styles.text18} numberOfLines={2}>
        {eta.prefix}
        {!!eta.value && (
          <AVText
            style={
              p.orderType === 'OrderNow' ? styles.text18 : styles.text18Bold
            }
          >
            {eta.value}
          </AVText>
        )}
      </AVText>
      <View style={styles.v6} />
      <AVText style={styles.text18} numberOfLines={3} ellipsizeMode="tail">
        {`${Localized?.Labels?.pickup_at_prefix ?? 'Pickup at'} `}
        <AVText numberOfLines={2} style={styles.text18Bold}>
          {locationLine}
        </AVText>
      </AVText>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {marginBottom: tokens.spacing.md, alignItems: 'center'},
  text18: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '400',
    textAlign: 'center',
    fontFamily: getButtonDescriber().buttonTextFontFamily(),
    color: Styles.Colors.PayNew.black01,
  },
  text18Bold: {
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: getButtonDescriber().buttonTextFontFamily(),
    color: Styles.Colors.PayNew.black01,
  },
  v6: {height: 6},
});

export default Header;
